import React from 'react';
import { Trans } from '@lingui/react/macro';

import { Button } from '@rover/kibble/core';

import { RevampDatesSelection } from './useRevampDatesSelection';

type Props = {
  selection: RevampDatesSelection;
};

const RevampDatesSaveButton = ({ selection }: Props): JSX.Element => (
  <Button variant="primary" fullWidth disabled={!selection.canSave} onPress={selection.handleSave}>
    <Trans>Save dates</Trans>
  </Button>
);

export default RevampDatesSaveButton;
